import { render } from "./PageProfile.vue?vue&type=template&id=580a1d40&scoped=true"
import script from "./PageProfile.vue?vue&type=script&lang=js"
export * from "./PageProfile.vue?vue&type=script&lang=js"

import "./PageProfile.vue?vue&type=style&index=0&id=580a1d40&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-580a1d40"]])

export default __exports__